import { createSlice, PayloadAction, Slice } from '@reduxjs/toolkit';

import { StoreModelType } from './types';

export interface StoreModelStateProps {
    storeConnectionId?: { [key in keyof StoreModelType]: string };
}

const initialState: StoreModelStateProps = {};

export const storeModelSlice: Slice<StoreModelStateProps> = createSlice({
    name: 'storeModel',
    initialState,
    reducers: {
        setStoreConnectionId: (state, action: PayloadAction<{ [key in keyof StoreModelType]: string }>) => {
            state.storeConnectionId = {
                ...(state.storeConnectionId || {}),
                ...action.payload,
            };
        },
    },
    extraReducers: () => {},
});

export const { setStoreConnectionId } = storeModelSlice.actions;

export default storeModelSlice.reducer;
